// src/components/comments/CommentSelectionChip.jsx
//
// A small floating "+ Comment" chip that appears next to a live text selection
// in the editor (Google-Docs style). Clicking it opens the Comments sidebar with
// the selected text pre-filled as the quote — collapsing the old multi-step
// "open sidebar → New Comment → Highlight Quote → go select text" flow into a
// single gesture: select, then click.
//
// Purely presentational + positioned: the parent owns the selection text and the
// viewport coordinates, and supplies onClick.
import React from 'react';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

export default function CommentSelectionChip({ chip, onClick }) {
  if (!chip) return null;

  return (
    <button
      type="button"
      // Mouse-down (not click) so we act before the browser collapses the
      // selection, and stop it from bubbling into the editor's handlers.
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick?.();
      }}
      style={{
        position: 'fixed',
        top: chip.top,
        left: chip.left,
        transform: 'translate(-50%, -100%)',
        zIndex: 1500,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '6px 12px',
        background: '#5A52A3',
        color: '#fff',
        border: 'none',
        borderRadius: 999,
        boxShadow: '0 4px 14px rgba(0,0,0,0.25)',
        fontSize: 13,
        fontWeight: 600,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
      }}
      title="Comment on the selected text"
    >
      <ChatBubbleOutlineIcon sx={{ fontSize: 16 }} />
      Comment
    </button>
  );
}
